export class RedsysPaymentConfig {
    public creditCardEnabled: boolean = false;
    public bizumEnabled: boolean = false;
    public merchantCode?: string;
    public password?: string;
    public environment?: RedsysEnvironmentType;

    constructor(json?: any) {
        if (!json) {
            return;
        }

        Object.assign(this, json);
    }

    public clone(): RedsysPaymentConfig {
        const redsysPaymentConfig: RedsysPaymentConfig = new RedsysPaymentConfig();

        redsysPaymentConfig.creditCardEnabled = this.creditCardEnabled;
        redsysPaymentConfig.bizumEnabled = this.bizumEnabled;
        redsysPaymentConfig.merchantCode = this.merchantCode;
        redsysPaymentConfig.password = this.password;
        redsysPaymentConfig.environment = this.environment;

        return redsysPaymentConfig;
    }
}

export enum RedsysEnvironmentType {
    Test,
    Live,
}
